<template>
  <div class="swiper-container p-ft__wrap p-ft__wrap--bottom">
    <div v-if="note.links" class="swiper-wrapper p-ft__wrapFlex">
      <a v-if="btnShow[0]" class="swiper-slide p-ft__wrapLink" :href="urls.page_technology">
        <picture>
          <source media="(max-width: 900px)" :srcset="`${assets_path}images/benefit/photo-external1_sp.jpg`">
          <img class="p-ft__wrapLink__bg" :src="`${assets_path}images/benefit/photo-external1_pc.jpg`" alt="" width="400" height="400">
        </picture>
        <div class="p-ft__wrapLink__info">
          <h3 v-html="note.links.feature2"></h3>
        </div>
        <div class="p-ft__wrapLink__more c-btnViewMore c-btnViewMore--min">
          <div class="c-btnViewMore__text"></div>
          <div class="c-btnViewMore__bg"></div>
        </div>
      </a>
      <a v-if="btnShow[3]" class="swiper-slide p-ft__wrapLink" :href="urls.page_benefit">
        <picture>
          <source media="(max-width: 900px)" :srcset="`${assets_path}images/technology/photo-external1_sp.jpg`">
          <img class="p-ft__wrapLink__bg" :src="`${assets_path}images/technology/photo-external1_pc.jpg`" alt="" width="400" height="400">
        </picture>
        <div class="p-ft__wrapLink__info">
          <h3 v-html="note.links.feature1"></h3>
        </div>
        <div class="p-ft__wrapLink__more c-btnViewMore c-btnViewMore--min">
          <div class="c-btnViewMore__text"></div>
          <div class="c-btnViewMore__bg"></div>
        </div>
      </a>

      <a v-if="btnShow[1]" class="swiper-slide p-ft__wrapLink" :href="urls.citizen_tech" target="_blank" rel="noopener">
        <picture>
          <source media="(max-width: 900px)" :srcset="`${assets_path}images/benefit/photo-external2_sp.jpg`">
          <img class="p-ft__wrapLink__bg" :src="`${assets_path}images/benefit/photo-external2_pc.jpg`" alt="" width="400" height="400">
        </picture>
        <div class="p-ft__wrapLink__info">
          <h3 v-html="note.links.supertitanium"></h3>
        </div>
        <div class="p-ft__wrapLink__more c-btnViewWeb c-btnViewWeb--min">
          <div class="c-btnViewWeb__text"></div>
          <div class="c-btnViewWeb__bg"></div>
        </div>
      </a>
      <a v-if="btnShow[4]" class="swiper-slide p-ft__wrapLink" :href="urls.manufacture" target="_blank" rel="noopener">
        <picture>
          <source media="(max-width: 900px)" :srcset="`${assets_path}images/technology/photo-external2_sp.jpg`">
          <img class="p-ft__wrapLink__bg" :src="`${assets_path}images/technology/photo-external2_pc.jpg`" alt="" width="400" height="400">
        </picture>
        <div class="p-ft__wrapLink__info">
          <h3 v-html="note.links.manufacture"></h3>
        </div>
        <div class="p-ft__wrapLink__more c-btnViewWeb c-btnViewWeb--min">
          <div class="c-btnViewWeb__text"></div>
          <div class="c-btnViewWeb__bg"></div>
        </div>
      </a>

      <a v-if="btnShow[2]" class="swiper-slide p-ft__wrapLink" :href="urls.reuters_site" target="_blank" rel="noopener">
        <picture>
          <source media="(max-width: 900px)" :srcset="`${assets_path}images/benefit/photo-external3_sp.jpg`">
          <img class="p-ft__wrapLink__bg" :src="`${assets_path}images/benefit/photo-external3_pc.jpg`" alt="" width="400" height="400">
        </picture>
        <div class="p-ft__wrapLink__info p-ft__wrapLink__info--left">
          <h3 v-html="note.links.reuters"></h3>
          <div class="p-ft__wrapLink__infoReuters">
            <img class="isReuters" :src="`${assets_path}images/common/logo-reuters.png`" alt="REUTERS" width="342" height="70">
          </div>
        </div>
        <div class="p-ft__wrapLink__more c-btnViewWeb c-btnViewWeb--min">
          <div class="c-btnViewWeb__text"></div>
          <div class="c-btnViewWeb__bg"></div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
  import { assets_path, breakpoint } from '@/_modules/utils/variables';
  import store from '@/_modules/stores';
  import Swiper from 'swiper';

  export default {
    components: {

    },
    props: ['page'],
    data() {
      return {
        assets_path: assets_path,
        ispc: false,
        urls: {},
        note: {},
        swiper: null,
        btnShow: [
          true,
          true,
          true,
        ]
      }
    },
    store,
    computed: {},
    created() {},
    mounted() {
      this.urls = this.$store.getters.getUrls;
      this.note = this.$store.getters.getNote;

      this.resize();
      window.addEventListener('resize', this.resize);

      if (this.page === 'benefit') {
        this.btnShow[0] = true;
        this.btnShow[1] = true;
        this.btnShow[2] = true;
        this.btnShow[3] = false;
        this.btnShow[4] = false;
      } else if (this.page === 'technology') {
        this.btnShow[0] = false;
        this.btnShow[1] = false;
        this.btnShow[2] = true;
        this.btnShow[3] = true;
        this.btnShow[4] = true;
      }

      this.$nextTick(this.start);
    },
    methods: {
      start() {

      },
      setSlider() {
        this.swiper = new Swiper('.swiper-container', {
          speed: 400,
          spaceBetween: 0,
          slidesPerView: 2,
          centeredSlides: true,
          initialSlide: 1
        });
      },
      resize() {
        this.$nextTick(() => {
          if (window.innerWidth > breakpoint) {
            this.ispc = true;
            if (this.swiper) {
              this.swiper.destroy();
              this.swiper = null;
            }
          } else {
            this.ispc = false;
            if (!this.swiper) {
              this.setSlider();
            } else {
              this.swiper.update();
            }
          }
        });
      }
    }
  }
</script>
